import { CommonService } from './../../../services/common/common.service';
// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';
// Service Class
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { CppService } from './../../../services/cpp/cpp.service';
import { SeedReturnService } from './../../../services/seed/seed-return.service';

// Class
import { CPPItemsFilter } from './../../../models/CPP/CPPItemsFilter';
import { CPPOrderSummaryVM } from './../../../models/CPP/CPPOrderSummaryVM';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ToastrService } from 'ngx-toastr';
import { MasterConstants } from './../../../common/constants/master-constants';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { MobilePDFVM } from '../../../models/CPP/MobilePDFVM';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-cpp-order-summary',
  templateUrl: './cpp-order-summary.component.html',
  styleUrls: ['./cpp-order-summary.component.scss']
})
export class CppOrderSummaryComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  isInstructionType = false;
  emails: any;
  emailButtonClicked = false;
  configurationMessage: any[];
  errorData: any[];
  ifAnyError = false;
  statusNotice = '';
  deliveryDate: Date;
  webOrderNumber = '';
  specialInstructionText = '';
  isBulkItemAvailable = false;
  bulkContactName = '';
  dynamicDisclaimerMessage: string;
  bulkContactNumber = '';
  isPackagedItemAvailable = false;
  packagedContactName = '';
  packagedContactNumber = '';
  contactEmailAddress = '';
  packagedDeliveryInst = '';
  splitId: number;
  showErrorItems: boolean;
  showPDFIcon: boolean;
  totalOrderCost = 0;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  orderStatus = '';
  filter: any = new CPPItemsFilter();
  cppProductItemsDataSource: any[];
  cppProductItemsDataSource2: any[];
  shipToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  deliverToAccountdetails: any = {};
  ascAccountDetails: any = {};
  dsmAccountDetails: any = {};
  statusNoticeData: any = {};
  showBackToCppLanding: boolean;
  pdfDataObject: any;
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  jdeorderNumber = '';
  customerPONumber = '';
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  isInMobileApp = false;
  @ViewChild('contractsPaginator', { read: MatPaginator }) contractsPaginator: MatPaginator;
  isRedirectedFromPlacedOrder = false;
  isRedirectedFromSraOrder = false;
  readOnlyAccess = false;
  filter2: MobilePDFVM = new MobilePDFVM();
  basePdfData: string;
  plAccess = false;
  disclaimerMessage: string;
  shouldShowSurveyMessage: boolean = false;
  evolveSurveyUrl: string = '';
  constructor(private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private datePipe: DatePipe,
    private cppService: CppService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private seedReturnService: SeedReturnService) { }

  ngOnInit() {
    this.isInMobileApp = this.isInWebView();
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.GetDisclaimerMessage();
    this.loaderService.setLoaderStatus(true);
    const summaryScreenFrom = this.cppService.redirectFrom;
    if (summaryScreenFrom === 'placeOrder') {
      this.isRedirectedFromPlacedOrder = true;
      this.cppService.setRedirectionFrom('');
    }
    const summaryScreenFromSra = this.cppService.redirectFromSra;
    if (summaryScreenFromSra === 'sra-orders') {
      this.isRedirectedFromSraOrder = true;
      this.cppService.redirectFromSra = '';
    }
    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
    }
    if (this.cppService.webOrderNumberAndSplitId) {
      var data = this.cppService.webOrderNumberAndSplitId.split('~');
      this.webOrderNumber = data[0];
      this.splitId = +data[1];
      this.showErrorItems = data[2] === 'error' ? true : false;
      this.showPDFIcon = this.showErrorItems;
      this.showBackToCppLanding = data[3] === 'CPPLanding' ? true : false;

      this.evolveSurveyUrl = this.cppService.evolveSurveyUrl;
      this.shouldShowSurveyMessage = this.cppService.shouldShowSurveyMessage;

      this.getOrderSummaryData();
    } else {
      this.router.navigate(['/cpp/landing-data']);
      this.commonService.currentTabIndex.next(0);
    }

    this.statusNoticeData.withoutSplitNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_STATUS');
    this.statusNoticeData.splitNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_SPLIT_STATUS');
    this.statusNoticeData.errorNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_ERROR_STATUS');
    this.statusNoticeData.partialSplitStatus = this.configurationMessage.filter(x => x.id === 'PARTIAL_SPLIT');

    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER);
  }

  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }

  GetDisclaimerMessage() {
    this.subscription.push(this.cppService.GetDisclaimerMessage().subscribe((result: any) => {
      if (result) {
        this.dynamicDisclaimerMessage = result.message;
      }
    }));
  }

  //
  getErrorMessagesForProduct(item) {
    let message = '';
    const configMessage = this.configurationMessage.filter(x => x.id === 'SPLIT_ERROR');
    if (configMessage && configMessage.length > 0) {
      message = configMessage[0].value;
    }
    return message;
  }
  //
  getDeliveryDate(item: any) {
    let data;
    if (item && item.productDetail && item.productDetail.length > 0) {
      data = item.productDetail[0].desiredDeliveryDate;
    }
    return data;
  }

  getDeliveryDateReason(item: any) {
    let data;
    if (item && item.productDetail && item.productDetail.length > 0) {
      data = item.productDetail[0].deliveryDateChangeReason;
    }
    return data;
  }

  getTooltipText(item: any): string {
    const tooltipValue = this.getDeliveryDateReason(item);
    return `Arrival Date Reason Change\n${tooltipValue}`;
  }

  openEmailSection() {
    this.emailButtonClicked = true;
  }
  //
  sendEmail() {
    this.emailButtonClicked = false;
  }
  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.prepayContractOuter').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // Generate Pdf report
  generatePdf() {
    if (this.pdfDataObject) {
      const documentDefinition = this.getDocumentDefinition();
      if (this.isInMobileApp) {
        const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
        pdfDocGenerator.getBase64((data) => {
          this.basePdfData = data;
          const currentDateTime = new Date();
          this.filter2 = {
            MobilePDFBase64: this.basePdfData,
            FileName: 'CPPOrder_' + this.pdfDataObject.webOrderNumber + '_' + currentDateTime.getDate() + (currentDateTime.getMonth() + 1) + currentDateTime.getFullYear() + '_' + currentDateTime.getHours() + currentDateTime.getMinutes() + currentDateTime.getSeconds() + '.pdf'
          };
          this.subscription.push(this.cppService.sendBaseDate(this.filter2).subscribe((result) => {
            
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        });
      } else {
        pdfMake.createPdf(documentDefinition).download('CPP_Order_' + this.pdfDataObject.webOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
      }
    } else {
      let errorMsg = 'No data available for WebOrderNumber #' + this.pdfDataObject.webOrderNumber;
      this.toastrService.error(errorMsg);
      this.setErrorAnalytics(errorMsg);
    }
  }

  // PDF document defination
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    const orderCreateDate = this.pdfDataObject.createdOnString;
    let displayWith = [];
    let columnList = [];
    let valueList = [];
    let bulkdetailsheader;

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',
      ];
    }
    // ShipTo & SoldTo Account available
    else if (!this.deliverToAccountdetails.AccountName && this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',

      ];
    }

    bulkdetailsheader = {
      body: [
        ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
        ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
        ['PLACED BY:', this.pdfDataObject.placedByName],
        ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
      ]
    };

    if (this.isBulkItemAvailable) {
      bulkdetailsheader.body.push(['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName]);
      bulkdetailsheader.body.push(['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber]);
    }

    if (this.isPackagedItemAvailable) {
      if (this.packagedContactName) bulkdetailsheader.body.push(['CONTACT NAME:', this.pdfDataObject.packagedContactName]);
      if (this.packagedContactNumber) bulkdetailsheader.body.push(['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber]);
      if (this.packagedDeliveryInst) bulkdetailsheader.body.push(['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst]);
    }
    if (this.contactEmailAddress) bulkdetailsheader.body.push(['Non-Subscriber Email(s):', this.pdfDataObject.contactEmailAddress]);

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          layout: 'noBorders',
          table: bulkdetailsheader,
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },

        {
          table: {
            widths: displayWith,
            headerRows: 1,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.disclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          margin: [40, 5, 40, 0]
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.dynamicDisclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          widths: ['*'],
          margin: [40, 0, 40, 0]
        },

        this.getContractPdfObject(this.pdfDataObject.splitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + '  (CST). If you have any questions regarding these changes, please contact WinField United Customer Service, 1-855-494-6343'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#feeaa6',
          color: '#757575'
        },
        tablePayment: {
          fontSize: 8,
          background: '#b4e3df',
          color: '#757575'
        },
        tableRepack: {
          fontSize: 8,
          background: '#FDCF35',
          color: '#0b3f54'
        },
        itemFlashMsgDescBorder:
        {
          color: 'red'
        }
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    const tblObject = [];
    let colum = [];
    let columnshippingInStruction = [];
    const isRedirected: boolean = this.isRedirectedFromPlacedOrder;
    let itemFlashMsgDescCount = [];
    splitDetails.forEach(obj => {
      itemFlashMsgDescCount = obj.productDetail.filter((obj) => obj.itemFlashMsgDesc != null && obj.itemFlashMsgDesc != '');
    });
    const count = itemFlashMsgDescCount.length;
    if (count > 0) {
      splitDetails.forEach(obj => {
        const cppOrderDetails = obj.productDetail;
        let jdeNumber = '';
        if (obj.jdeorderNumber) {
          jdeNumber = obj.jdeorderNumber;
        }
        columnshippingInStruction = [{
          text: 'Shipping Instructions: ' + (this.specialInstructionText ? this.specialInstructionText : ''),
          alignment: 'left',
        }];

        const tblHeaderShippingInstruction = [
          {
            style: 'pageText',
            widths: ['100%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: columnshippingInStruction
          }
        ];
        tblObject.push(tblHeaderShippingInstruction);
        if (isRedirected) {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
            alignment: 'right',
          }];
        }
        else if (jdeNumber == '') {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          },
          {
            text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
            alignment: 'right',
          }];
        }
        else {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Sales Order #: ' + jdeNumber,
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          },
          {
            text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
            alignment: 'right',
          }];
        }
        const tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];
        tblObject.push(tblHeader);
        const tbl = {
          table: {
            widths: ['55%', '15%', '15%', '15%'],
            color: '#0b3f54',
            body: [
              [{
                text: 'Product',
                style: 'tableHeader'
              },
              {
                text: 'Ordered Quantity',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Ordering UOM',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Total',
                style: 'tableHeader', alignment: 'center'
              },

              ],
              ...cppOrderDetails.map(cpp => {
                var cellData = [],
                  cellData = this.cppModifiedCellData(cpp);
                return [
                  {
                    text: cellData
                  },
                  {
                    text: cpp.itemFlashMsgDesc, style: 'itemFlashMsgDescBorder', alignment: 'center'
                  },
                  { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                  { text: cpp.uom, alignment: 'center' },
                  { text: cpp.totalGallons, alignment: 'center' },
                ];
              })
            ]
          },
          style: 'tablefont',
        };
        tblObject.push(tbl);
      });
    } else {
      splitDetails.forEach(obj => {
        const cppOrderDetails = obj.productDetail;
        let jdeNumber = '';
        if (obj.jdeorderNumber) {
          jdeNumber = obj.jdeorderNumber;
        }
        columnshippingInStruction = [{
          text: 'Shipping Instructions: ' + (this.specialInstructionText ? this.specialInstructionText : ''),
          alignment: 'left',
        }];

        const tblHeaderShippingInstruction = [
          {
            style: 'pageText',
            widths: ['100%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: columnshippingInStruction
          }
        ];
        tblObject.push(tblHeaderShippingInstruction);
        if (isRedirected) {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
            alignment: 'right',
          }];
        }
        else if (jdeNumber == '') {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          },
          {
            text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
            alignment: 'right',
          }];
        }
        else {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Sales Order #: ' + jdeNumber,
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          },
          {
            text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
            alignment: 'right',
          }];
        }
        const tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
        const tbl = {
          table: {
            widths: ['55%', '15%', '15%', '15%'],
            color: '#0b3f54',
            body: [
              [{
                text: 'Product',
                style: 'tableHeader'
              },
              {
                text: 'Ordered Quantity',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Ordering UOM',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Total',
                style: 'tableHeader', alignment: 'center'
              },

              ],
              ...cppOrderDetails.map(cpp => {
                var cellData = [],
                  cellData = this.cppModifiedCellData(cpp);
                return [
                  {
                    text: cellData
                  },
                  { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                  { text: cpp.uom, alignment: 'center' },
                  { text: cpp.totalGallons, alignment: 'center' },
                ];
              })
            ]
          },
          style: 'tablefont',
        };
        tblObject.push(tbl);
      });
    }
    return tblObject;
  }
  formatQuantity(value: string): string {
    if (!value) return '';
    const parts = value.split(' ');
    const num = parseFloat(parts[0]);
    const unit = parts[1] || '';

    if (unit === 'GA' || unit === 'LB') {
      return num.toFixed(2) + ' ' + unit; // always 2 decimals
    }

    return value; // unchanged
  }

  // For your price and payment Term in the cell with style
  cppModifiedCellData(cpp) {
    const tempArray = [];
    if (cpp.itemVendorName) {
      tempArray.push(cpp.itemVendorName + ' \n' + cpp.itemDescription + '\n');
    }
    else {
      tempArray.push('' + cpp.itemDescription + '\n');
    }
    if (this.plAccess == true && cpp.yourPrice != null && cpp.yourPrice != '' && cpp.yourPrice != undefined && cpp.yourPrice != 0) {
      tempArray.push({
        text: ('$' + cpp.yourPrice.toFixed(4) + '/' + cpp.pricingUOM + '\n'), style: 'tableUnit'
      });
    }
    if (this.plAccess == true && cpp.paymentTerms != null && cpp.paymentTerms != '' && cpp.paymentTerms != undefined) {
      tempArray.push({
        text: (cpp.paymentTerms.trim() + '\n'), style: 'tablePayment'
      });
    }
    if ((cpp.isRepackItem == 'Y' && cpp.repackAgreement == 'N') || (cpp.isRepackItem == 'Y' && cpp.repackAgreement == null) || (cpp.isRepackItem == 'Y' && cpp.repackAgreement == '')) {
      tempArray.push({
        text: ('A Repack Agreement is expired or missing for ' + cpp.itemDescription + '. This item will not ship until a repack agreement has been signed. Please reach out to winfieldcustomerservice@landolakes.com or 855-494-6343 to get an agreement sent.'), style: 'tableRepack'
      });
    }
    return tempArray;
  }

  // get Order Summary Data for display and PDF
  getOrderSummaryData() {
    this.subscription.push(this.cppService.getOrderSummaryDetails(this.webOrderNumber).subscribe((result: CPPOrderSummaryVM) => {
      this.pdfDataObject = result;
      this.cppProductItemsDataSource2 = result.splitDetails;
      this.contactEmailAddress = result.contactEmailAddress;
      this.cppProductItemsDataSource2.forEach(x => {
        x.productDetail.forEach(prod => {
          if (prod.bulkPackaged == 'bulk' || prod.bulkPackaged == 'BULK') {
            //this.bulkContactName = this.pdfDataObject.bulkContactName;
            //this.bulkContactNumber = this.pdfDataObject.bulkContactNumber;
            this.isBulkItemAvailable = true;
          }
          if (prod.bulkPackaged == "packaged" || prod.bulkPackaged == "PACKAGED") {
            this.packagedContactName = this.pdfDataObject.packagedContactName;
            this.packagedContactNumber = this.pdfDataObject.packagedContactNumber;
            this.packagedDeliveryInst = this.pdfDataObject.packagedDeliveryInst;
            this.isPackagedItemAvailable = true;
          }
        });
      });

      if (result && result.splitDetails && result.splitDetails.length > 0 && result.splitDetails.filter(x => x.splitId == 1).length > 0) {
        this.showPDFIcon = false;
      }
      else {
        this.showPDFIcon = true;
      }
      if (result && result.splitDetails && result.splitDetails.length > 0) {
        if (result.splitDetails.length == 1 && !result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.withoutSplitNoticeStatus[0].value;
        }
        else if (result.splitDetails.length > 1 && !result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.splitNoticeStatus[0].value;
        }
        else if (result.splitDetails.length > 1 && result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.partialSplitStatus[0].value;
        }
        if (this.showErrorItems) {
          this.cppProductItemsDataSource = result.splitDetails.filter(x => x.splitId == 1);
          if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.length > 0) {
            this.totalNumbersOfOrder = this.cppProductItemsDataSource.length;
            this.cppProductItemsDataSource.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.originalOrderQuantity = x.originalOrderQuantity ? x.originalOrderQuantity.toFixed(this.commonService.countDecimals(x.originalOrderQuantity)) : x.originalOrderQuantity;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
          }
          this.statusNotice = this.statusNoticeData.errorNoticeStatus[0].value;
        } else {
          this.cppProductItemsDataSource = result.splitDetails;
          if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.length > 0) {
            this.totalNumbersOfOrder = this.cppProductItemsDataSource.length;
            this.cppProductItemsDataSource.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.originalOrderQuantity = x.originalOrderQuantity ? x.originalOrderQuantity.toFixed(this.commonService.countDecimals(x.originalOrderQuantity)) : x.originalOrderQuantity;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
          }
          this.errorData = result.splitDetails.filter(x => x.splitId == 1);
          if (this.errorData && this.errorData.length > 0) {
            this.ifAnyError = true;
            if (this.errorData.length == result.splitDetails.length) {
              this.statusNotice = this.statusNoticeData.errorNoticeStatus[0].value;
            }
          }
        }

        this.webOrderNumber = result.webOrderNumber;
        this.specialInstructionText = result.specialInstructionText;
        this.orderStatus = result.orderStatus;
        this.deliveryDate = result.desiredDeliveryDate;
        this.shipToAccountdetails.AccountNumber = result.accountNumber;
        this.shipToAccountdetails.AccountName = result.accountName;
        this.shipToAccountdetails.Address1 = result.accountAddress1;
        this.shipToAccountdetails.Address2 = result.accountAddress2.replace('<br>', '');
        this.shipToAccountdetails.AccountCity = result.accountCity;
        this.shipToAccountdetails.AccountState = result.accountState;
        this.shipToAccountdetails.AccountZipCode = result.accountZipCode;
        this.shipToAccountdetails.HeaderText = result.headerText;
        this.shipToAccountdetails.InstructionType = result.instructionType;
        this.shipToAccountdetails.CustomerPickUp = result.customerPickUp == 'N' ? 'NO' : 'YES';
        this.shipToAccountdetails.PlacedByName = result.placedByName;
        this.shipToAccountdetails.CreatedOn = result.createdOn;

        // this.deliverToAccountdetails
        if (result.deliverToDetail) {
          this.deliverToAccountdetails.AccountNumber = result.deliverToDetail.accountNo;
          this.deliverToAccountdetails.AccountName = result.deliverToDetail.accountName;
          this.deliverToAccountdetails.Address1 = result.deliverToDetail.address1;
          this.deliverToAccountdetails.AccountCity = result.deliverToDetail.city;
          this.deliverToAccountdetails.AccountState = result.deliverToDetail.state;
          this.deliverToAccountdetails.AccountZipCode = result.deliverToDetail.zipCode;
        }

        // this.soldToAccountdetails
        if (result.soldToDetail) {
          this.soldToAccountdetails.AccountNumber = result.soldToDetail.accountNo;
          this.soldToAccountdetails.AccountName = result.soldToDetail.accountName;
          this.soldToAccountdetails.Address1 = result.soldToDetail.address1;
          this.soldToAccountdetails.Address2 = result.soldToDetail.address2.replace('<br>', '');
          this.soldToAccountdetails.AccountCity = result.soldToDetail.city;
          this.soldToAccountdetails.AccountState = result.soldToDetail.state;
          this.soldToAccountdetails.AccountZipCode = result.soldToDetail.zipCode;
          this.soldToAccountdetails.RepackAgreement = result.soldToDetail.repackAgreement;
        }

        if (result.ascDetail) {
          this.ascAccountDetails.AccountName = result.ascDetail.ascName;
          this.ascAccountDetails.AscAddress1 = result.ascDetail.ascAddress1;
          this.ascAccountDetails.AscAddress2 = result.ascDetail.ascAddress2;
          this.ascAccountDetails.Phone = result.ascDetail.primaryPhone;
          this.ascAccountDetails.Email = result.ascDetail.emailAddress;
          this.ascAccountDetails.City = result.ascDetail.city;
          this.ascAccountDetails.State = result.ascDetail.state;
          this.ascAccountDetails.ZipCode = result.ascDetail.zipCode;
        }

        if (result.dsmDetail) {
          this.dsmAccountDetails.AccountName = result.dsmDetail.dsmAccountName;
          this.dsmAccountDetails.dsmAddress1 = result.dsmDetail.dsmAddress1;
          this.dsmAccountDetails.Phone = result.dsmDetail.primaryPhone;
          this.dsmAccountDetails.Email = result.dsmDetail.emailAddress;
          this.dsmAccountDetails.City = result.dsmDetail.city;
          this.dsmAccountDetails.State = result.dsmDetail.state;
          this.dsmAccountDetails.ZipCode = result.dsmDetail.zipCode;
        }
        this.jdeorderNumber = result.jdeorderNumber;
        this.shipToAccountdetails.CustomerPONumber = result.custPONumber;

        if (this.shouldShowSurveyMessage) {
          this.showSurveyMessage();
        }

      }
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Navigate  to CPP landing page
  backToLandingPage() {
    if (this.isRedirectedFromSraOrder) {
      this.router.navigate(['/cpp/orders/sra-order-landing']);
      this.commonService.currentTabIndex.next(1);
    }
    else {
      this.router.navigate(['/cpp/landing-data']);
      this.commonService.currentTabIndex.next(0);
    }
  }

  // Navigate  to CPP error maintenance screen
  backToErrorMaintenancePage() {
    if (this.isRedirectedFromSraOrder) {
      this.router.navigate(['/sro/error/order-maintenance-dashboard']);
    }
    else {
      this.router.navigate(['/cpp/error-order-maintenance-dashboard']);
    }
    
  }

  NavigateToOTISummaryPage(salesOrderNumber: number, orderType: string) {
    if (this.isRedirectedFromSraOrder) {
      this.cppService.redirectFromSra = 'sra-orders-oti';
    }
    this.router.navigate(['/oti/oti-order-summary', salesOrderNumber, orderType], { queryParams: { backToCppOrderSummary: true, webOrderNumber: this.webOrderNumber } });
  }

  setErrorAnalytics(errorMsg) {
    var eventData = {
      'event': 'form_error',
      'formName': 'Evolve – Crop Protection Order',
      'errorMessage': errorMsg
    };

    this.commonService.setDataLayerAnalytics(eventData);
  }

  showSurveyMessage() {
    const title = 'Evolve Survey';
    const message = 'We value your insights on the Evolve Order Management Application. Please take 2-3 minutes to complete this feedback survey and help us enhance your experience. Your responses are confidential. Thank you for participating!';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '450px',
      data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', labelLater: 'Later', dialogType: 'surveyForm' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe((res: string) => {
      this.saveSurveyPreference(res);
    }));
  }

  saveSurveyPreference(userSurveyPref) {
    if (userSurveyPref === 'YES') {
      window.open(this.evolveSurveyUrl, '_blank', 'noopener,noreferrer');
    }
    this.loaderService.setLoaderStatus(true);
    var response = JSON.stringify(userSurveyPref);
    this.subscription.push(this.seedReturnService.saveSurveyPreference(response).subscribe((result: any) => {
      this.loaderService.setLoaderStatus(false);

    }, error => this.loaderService.setLoaderStatus(false)));
  }

  ngOnDestroy() {
    this.cppService.webOrderNumberAndSplitId = undefined;
    this.cppService.shouldShowSurveyMessage = false;
    this.cppService.evolveSurveyUrl = '';
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Create a new Cpp order(navigate to new order screen)
  createNewOrder() {
    this.cppService.setCppOrderId(0);
    this.router.navigate(['/cpp/cpp-order-create']);
  }
}
